import getQueryList from './getQueryList';

export default function checkIsOrderBumpShownInQuery(priceReference, query = {}) {
  if (!priceReference || !query?.show_order_bumps) return false;

  return getQueryList(query.show_order_bumps).includes(priceReference);
}
